import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

const RightIcon = (props) => (
  <SVGUniqueID>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="#fff"
        d="M3.473 8.667h7.446L7.666 11.92a.672.672 0 000 .947c.26.26.68.26.94 0l4.393-4.394c.26-.26.26-.68 0-.94l-4.386-4.4a.664.664 0 10-.94.94l3.246 3.26H3.473c-.367 0-.667.3-.667.667 0 .367.3.667.667.667z"
      ></path>
    </svg>
  </SVGUniqueID>
);

export { RightIcon };
